import React from 'react';
import { useLocation } from 'react-router-dom';
export function Header() {
  const location = useLocation();
  const isCalculatorPage = location.pathname.includes('/calculator');
  return <div className="w-full py-3 text-center text-sm bg-dark-900" data-id="element-321">
      {isCalculatorPage ? <p className="text-white/90 px-4 sm:px-0 italic" data-id="element-322">
          For Private Equity Funds, Family Offices, and Strategic Acquirers
        </p> : <p className="text-white/90 px-4 sm:px-0" data-id="element-323">
          <span className="inline-flex items-center gap-1.5" data-id="element-324">
            New
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="text-[#00c853]" data-id="element-325">
              <path fill="currentColor" d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z" data-id="element-326" />
            </svg>
          </span>
          <span className="mx-2" data-id="element-327">·</span>
          Private equity firms, family offices, and strategic acquirers doing 4+
          acquisitions per year
        </p>}
    </div>;
}